import { styled } from "@mui/material";
import ContainedIconButton from "./ContainedIconButton";

const SubContainedIconButton = styled(ContainedIconButton)(() => ({
    position: 'absolute',
    zIndex: 1,
    bottom: '-0.45rem',
    right: '-0.45rem',
    padding: 0
}));

export default SubContainedIconButton;